import styled, { css } from 'styled-components';
import { TABLE_BORDER_COLOR } from 'HubStyleTokens/theme';
import GridItem from '../GridItem';
import { mediaQueries } from '../../utils/mediaQueries';
import { jsx as _jsx } from "react/jsx-runtime";
const sharedColumnStyles = css(["border-color:", ";border-style:solid;"], TABLE_BORDER_COLOR);
const RightColumn = styled(GridItem).withConfig({
  displayName: "RightColumnComp__RightColumn",
  componentId: "sc-1rgwxm9-0"
})(["", " overflow-x:auto;&&{padding:0 0 0 11px;}", "{&&{padding:24px 0 0 0;}}"], sharedColumnStyles, mediaQueries.belowLaptop);
const RightColumnComp = ({
  children,
  columnSpan
}) => {
  return /*#__PURE__*/_jsx(RightColumn, {
    columns: columnSpan,
    className: "right-column",
    children: children
  });
};
export default RightColumnComp;